import React from 'react';
import PropTypes from 'prop-types';

import Link from 'Components/Link';
import ContentFrame from 'Components/ContentFrame';
import SectionHeader from 'Components/SectionHeader';
import ContactLink from 'Components/ContactLink';
import TextBlock from 'Components/TextBlock';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import ConnectedFormattedImage from 'Containers/ConnectedFormattedImage';
import Button from 'Components/Button';
import { ROUTES } from 'Settings/route-strings';

const BuildingImageUri = require('Static/images/building.png');
const PlanetImageUri = require('Static/images/planet.png');

const getHeader = (type, error_code) => {
  const errorCode = (
    <ConnectedFormattedMessage
      id="errors.display_error_code"
      values={{ error_code }}
    />
  );
  switch (type) {
    case 'expiredTrial':
      return (
        <SectionHeader
          title={<ConnectedFormattedMessage id="errors.expired_trial_title" />}
        />
      );
    case 'pageNotFound':
    case 'permissionDenied':
      return (
        <SectionHeader
          title={<ConnectedFormattedMessage id="errors.generic_title" />}
          subtitle={errorCode}
        />
      );
    case 'modelDisabled':
      return (
        <SectionHeader
          title={<ConnectedFormattedMessage id="errors.model_disabled_title" />}
          // subtitle={'This model is currently disabled'}
        />
      );
    default:
      return (
        <SectionHeader
          title={<ConnectedFormattedMessage id="errors.unknown_title" />}
          subtitle={errorCode}
        />
      );
  }
};

const getBody = (type) => {
  switch (type) {
    case 'pageNotFound':
      return (
        <TextBlock
          description={
            <p className="TextBlock__paragraph">
              <ConnectedFormattedMessage
                id="errors.page_not_found"
                values={{
                  homepage_link: (
                    <Link to={ROUTES.INDEX}>schools.tinybop.com</Link>
                  ),
                }}
              />
            </p>
          }
        />
      );
    case 'expiredTrial':
      return [
        <TextBlock
          key="expired-body-message"
          description={
            <ConnectedFormattedMessage
              id="errors.expired_trial_description"
              convertToParagraphs
              values={{
                pricing_link: (
                  <Link key="pricing-link" to={ROUTES.PRICING}>
                    affordable pricing plans
                  </Link>
                ),
              }}
            />
          }
        />,
        <Button
          key="expired-body-button"
          route={ROUTES.SETTINGS_SUBSCRIPTION_ACTIVATION}
          buttonType="primary"
          label="Subscribe now"
        />,
      ];
    case 'permissionDenied':
      return (
        <TextBlock
          description={
            <p className="TextBlock__paragraph">
              <ConnectedFormattedMessage
                id="errors.permission_denied"
                values={{
                  contact_link: (
                    <ContactLink
                      label={
                        <ConnectedFormattedMessage id="contact_link.error_page_cta" />
                      }
                    />
                  ),
                }}
              />
            </p>
          }
        />
      );
    case 'apiLoadError':
      return (
        <TextBlock
          description={
            <p className="TextBlock__paragraph">
              <ConnectedFormattedMessage id="errors.resource_unavailable" />
            </p>
          }
        />
      );
    case 'modelDisabled':
      return (
        <TextBlock
          description={
            <div>
              <p className="TextBlock__paragraph">
                <ConnectedFormattedMessage id="errors.model_disabled" />
              </p>
              <p className="TextBlock__paragraph">
                <Link to={ROUTES.INDEX}>Browse Models</Link>
              </p>
            </div>
          }
        />
      );
    default:
      return (
        <TextBlock
          description={
            <ConnectedFormattedMessage
              id="errors.site_unavailable"
              convertToParagraphs
            />
          }
        />
      );
  }
};

const getGraphic = (type) => {
  switch (type) {
    case 'pageNotFound':
    case 'permissionDenied':
      return (
        <ConnectedFormattedImage
          className="ContentFrame__image"
          src={BuildingImageUri}
          style={{ maxWidth: '5em' }}
          altId="error_page.building_graphic.alt"
        />
      );
    default:
      return (
        <ConnectedFormattedImage
          className="ContentFrame__image"
          src={PlanetImageUri}
          style={{ maxWidth: '15em' }}
          altId="error_page.planet_graphic.alt"
        />
      );
  }
};

class Error extends React.PureComponent {
  render() {
    const { type, code } = this.props;
    return (
      <main className="Page__content">
        <ContentFrame pageType="with-graphic" size="medium">
          <div className="ContentFrame__body">
            {getHeader(type, code)}
            {getBody(type, code)}
          </div>
          <div className="ContentFrame__graphic">{getGraphic(type)}</div>
        </ContentFrame>
      </main>
    );
  }
}

Error.propTypes = {
  type: PropTypes.string.isRequired,
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Error.defaultProps = {
  code: 404,
};

export default Error;
